import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import { useCuentaCobroModel } from '../../../modelos/CuentasCobro/modeloCuentasCobro';
import React, { useEffect, useMemo, useState } from 'react';
import CuentaDeCobroCard from './cuentaCobroCard';
import ResumenTutorCard from './ResumenCard';
import { ChevronDown } from 'lucide-react';

const ModuloCuentasCobro = () => {
  console.log("ejecutando modulo cuenta cobro");
  const {
    cuentasDeCobro,
    loadingcuentaCobro,
    errorcuentaCobro,
    cargarCuentasCobros,
    setupWebSocketsCuentasCobro
  } = useCuentaCobroModel();
  const { configuracion } = useConfiguracion();

  // 1. Inicia el mes seleccionado como `null` para indicar que aún no se ha definido.
  const [mesSeleccionado, setMesSeleccionado] = useState(null);
  const [isResumenVisible, setIsResumenVisible] = useState(false);

  useEffect(() => {
    if (configuracion?.nombreEmpresa) {
      cargarCuentasCobros(configuracion.nombreEmpresa);
      const cleanupWebSockets = setupWebSocketsCuentasCobro(configuracion.nombreEmpresa);
      return () => {
        cleanupWebSockets();
      };
    }
  }, [configuracion]);
  
  const { 
    cuentasPorPagar, 
    cuentasPagadas, 
    estadisticasTutores, 
    totalPagado,
    mesesDisponibles,
    mesActivo // Exportamos el mes que se está usando para el filtro
  } = useMemo(() => {
    
    const mesesUnicos = new Set();
    cuentasDeCobro.forEach(cuenta => {
      if (cuenta.estado && cuenta.fechaPagadoPorNosotros) {
        const fechaPago = cuenta.fechaPagadoPorNosotros;
        const anio = fechaPago.getFullYear();
        const mes = String(fechaPago.getMonth() + 1).padStart(2, '0');
        mesesUnicos.add(`${anio}-${mes}`);
      }
    });

    const mesesCalculados = Array.from(mesesUnicos)
      .sort((a, b) => b.localeCompare(a))
      .map(mesStr => {
        const [anio, mesNum] = mesStr.split('-');
        const fecha = new Date(anio, mesNum - 1, 1);
        const etiquetaMes = fecha.toLocaleString('es-CO', { month: 'long' });
        return {
          valor: mesStr,
          etiqueta: `${etiquetaMes.charAt(0).toUpperCase() + etiquetaMes.slice(1)} de ${anio}`
        };
      });

    const listaDeMeses = [
      { valor: 'todos', etiqueta: 'Todos los meses' },
      ...mesesCalculados
    ];
    
    // 2. Determinamos el mes "efectivo" que se usará para filtrar.
    // Si el usuario aún no ha seleccionado un mes (`mesSeleccionado` es null)
    // y ya tenemos meses calculados, usamos el más reciente por defecto.
    // De lo contrario, usamos el que el usuario haya seleccionado.
    const mesActivoParaFiltrar = mesSeleccionado === null && listaDeMeses.length > 1
      ? listaDeMeses[1].valor // El más reciente
      : mesSeleccionado || 'todos'; // O el seleccionado, o 'todos' como fallback

    const pagadasFiltradas = cuentasDeCobro.filter(cuenta => {
      if (!cuenta.estado) return false;
      
      if (mesActivoParaFiltrar === 'todos') return true;
      
      if (!cuenta.fechaPagadoPorNosotros) return false;
      const [anio, mes] = mesActivoParaFiltrar.split('-').map(Number);
      const fechaPago = cuenta.fechaPagadoPorNosotros.toDate ? cuenta.fechaPagadoPorNosotros.toDate() : new Date(cuenta.fechaPagadoPorNosotros);
      return fechaPago.getFullYear() === anio && fechaPago.getMonth() + 1 === mes;
    }).sort((a, b) => {
        const fechaB = b.fechaPagadoPorNosotros?.toDate ? b.fechaPagadoPorNosotros.toDate() : new Date(b.fechaPagadoPorNosotros);
        const fechaA = a.fechaPagadoPorNosotros?.toDate ? a.fechaPagadoPorNosotros.toDate() : new Date(a.fechaPagadoPorNosotros);
        return fechaB.getTime() - fechaA.getTime();
    });

    const porPagarFiltradas = cuentasDeCobro
      .filter(cuenta => !cuenta.estado)
      .sort((a, b) => a.fechaPago - b.fechaPago);

    const estadisticas = pagadasFiltradas.reduce((acc, cuenta) => {
      const nombreTutor = cuenta.nameTutor || 'Tutor no especificado';
      if (!acc[nombreTutor]) {
        acc[nombreTutor] = { total: 0, cantidad: 0 };
      }
      acc[nombreTutor].total += cuenta.precioPagado;
      acc[nombreTutor].cantidad += 1;
      return acc;
    }, {});
    
    const totalPagadoMes = pagadasFiltradas.reduce((sum, cuenta) => sum + cuenta.precioPagado, 0);

    return {
      cuentasPorPagar: porPagarFiltradas,
      cuentasPagadas: pagadasFiltradas,
      estadisticasTutores: Object.entries(estadisticas).sort(([, a], [, b]) => b.total - a.total),
      totalPagado: totalPagadoMes,
      mesesDisponibles: listaDeMeses,
      mesActivo: mesActivoParaFiltrar // Devolvemos el mes activo
    };
  }, [cuentasDeCobro, mesSeleccionado]);
  
  /*
  useEffect(() => {
    if (mesSeleccionado === null && mesesDisponibles.length > 1) {
      setMesSeleccionado(mesesDisponibles[1].valor);
    }
  }, [mesesDisponibles, mesSeleccionado]);
  */


  if (loadingcuentaCobro) {
    return <div className="text-center p-8">Cargando...</div>;
  }

  if (errorcuentaCobro) {
    return <div className="text-center p-8 text-red-600">Error: {errorcuentaCobro}</div>;
  }

  console.log("cuentas pagadas", cuentasPagadas, cuentasPorPagar);

  return (
    <div className="w-full min-h-screen p-4 sm:p-6 lg:p-8 bg-gray-50">
      <div className="max-w-screen-2xl mx-auto">
        <h1 className="mb-6 text-3xl font-bold text-gray-800">Cuentas de Cobro</h1>
        
        <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className='lg:col-span-1'>
                <label htmlFor="filtro-mes" className="block text-sm font-medium text-gray-700 mb-1">
                    Filtrar por Mes
                </label>
                <select
                    id="filtro-mes"
                    // 4. El valor del select ahora es `mesActivo` para estar siempre sincronizado.
                    value={mesActivo}
                    onChange={(e) => setMesSeleccionado(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-lg shadow-sm focus:ring-blue-500 focus:border-blue-500"
                >
                    {mesesDisponibles.map(mes => (
                    <option key={mes.valor} value={mes.valor}>
                        {mes.etiqueta}
                    </option>
                    ))}
                </select>
            </div>
             <div className="p-4 bg-white rounded-lg shadow lg:col-span-2">
                <h3 className="text-sm font-medium text-gray-500">
                    {/* Usamos `mesActivo` para mostrar el título correcto desde el inicio */}
                    TOTAL PAGADO A COLABORADORES ({mesesDisponibles.find(m => m.valor === mesActivo)?.etiqueta})
                </h3>
                <p className="mt-1 text-3xl font-semibold text-gray-900">
                    ${totalPagado.toLocaleString('es-CO')}
                </p>
            </div>
        </div>

        {/* El resto del JSX no necesita cambios... */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          
          {/* === Columna izquierda === */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-blue-500">
              Por Pagar ({cuentasPorPagar.length})
            </h2>
            <div className="space-y-6">
              {cuentasPorPagar.length > 0 ? (
                cuentasPorPagar.map(cuenta => (
                  <CuentaDeCobroCard key={cuenta.idDocumento} cuenta={cuenta} />
                ))
              ) : (
                <p className="text-center text-gray-500 py-10">¡Excelente! No hay cuentas pendientes.</p>
              )}
            </div>
          </div>

          {/* === Columna derecha === */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4 pb-2 border-b-2 border-green-500">
              Historial de Pagos ({cuentasPagadas.length})
            </h2>
            
            <div className='mb-6 bg-white rounded-lg shadow-sm border border-gray-200'>
              <button
                onClick={() => setIsResumenVisible(!isResumenVisible)}
                className='w-full flex items-center justify-between p-3 text-left font-semibold text-gray-700 hover:bg-gray-50 rounded-lg'
              >
                <span className='text-lg'>Resumen por Tutor</span>
                <ChevronDown
                  className={`transition-transform duration-300 ${isResumenVisible ? 'rotate-180' : ''}`}
                  size={20}
                />
              </button>

              {isResumenVisible && (
                <div className='p-3 border-t border-gray-200 space-y-3'>
                  {estadisticasTutores.length > 0 ? (
                    estadisticasTutores.map(([nombre, data]) => (
                      <ResumenTutorCard key={nombre} nombre={nombre} total={data.total} cantidad={data.cantidad} />
                    ))
                  ) : (
                    <p className="text-center text-gray-500 py-4">No hay datos de pago para el periodo seleccionado.</p>
                  )}
                </div>
              )}
            </div>

            <div className="space-y-6">
              {cuentasPagadas.length > 0 ? (
                cuentasPagadas.map(cuenta => (
                  <CuentaDeCobroCard key={cuenta.idDocumento} cuenta={cuenta} />
                ))
              ) : (
                <p className="text-center text-gray-500 py-10">No se han registrado pagos en el periodo seleccionado.</p>
              )}
            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default ModuloCuentasCobro;